import {ProcessorCard} from "../processors/fragments/processorCard";
import {ProcessorHeader} from "../processors/fragments/processorHeader";
import {Button} from "@mantine/core";
import {DeviceMobileMessage} from "tabler-icons-react";
import {ProcessorCardBody} from "../processors/fragments/processorCardBody";
import {Handle, NodeProps, Position} from "reactflow";
import React, {useState} from "react";
import {NotifierModal} from "./notifierModal";

export function NotificationProcessor(props: NodeProps) {

    const [opened, setOpened] = useState(false);


    return (
        <>
            <ProcessorCard isSelected={props.selected}>
                <ProcessorHeader title="Notification Processor"/>
                <hr className={"smart-trigger-divider"}/>
                <ProcessorCardBody
                    body={" \"This is processor will convert your payload and pass it to the specific notifiers. Here you can connect one or more notification channels.\""}/>
                <div style={{display: "flex", justifyContent: "center", padding: "5px"}}>
                    <Button radius={"sm"}
                            onClick={() => setOpened(true)}
                            color={"gray"} rightIcon={<DeviceMobileMessage/>} size={"xs"} variant="outline">
                        ADD
                    </Button>
                </div>
            </ProcessorCard>
            <NotifierModal opened={opened} onClose={() => setOpened(false)}/>

            <Handle type="target" position={Position.Top} id="a"/>
            <Handle type="source" position={Position.Bottom} id="b"/>
        </>
    );
}
